import React from "react";

// * Components
import Book from "../../components/Book-Section/Book";
import PageInfo from "../../components/Products-Info-Section/PageInfo";

// * Datas
import { Histories } from "../../Data/ProductData";
import { homeObjOne } from "./Data";

function History() {
  return (
    <>
      <PageInfo {...homeObjOne} />
      <Book items={Histories} />
    </>
  );
}

export default History;
